module.exports = __webpack_public_path__ + "img/gjanLogo.aa2ef317.png";